import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { TeamOutlined, SearchOutlined, UndoOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Tab1 from "./Tab1";
import { Typography } from "@mui/material";

const FournisseurPage = () => {
    const auth = useAuthUser();
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true); 
    const [Enrege, setEnrege] = useState(true); 
    const [Annulactv, setAnnule] = useState(true); 
    const [FormAct, setFormactve] = useState(true);
    const [EtatG, setEtatG] = useState(false); 
    const [sbmit, setSbmit] = useState("");

    // --- PHASE 1 : CONSULTATION ---
    function HandleConsult() {
        const code = form.getFieldValue("CODEFOURNISSEUR");
        if (!code) {
            SweetAlert.fire("Alerte", "Veuillez choisir un code fournisseur.", "warning");
            return;
        }

        setLoading(true);
        axios.get(Data.ApiUrl.ReadFournisseur, { 
            headers: { 
                'Authorization': authHeader(), 
                'CypherSearch': Crypter.encrypt(code) 
            } 
        }).then((response) => {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode === 200) {
                const d = res.Result[0] || res.Result;

                // Application du mapping validé
                form.setFieldsValue({
                    CODEFOURNISSEUR: d.CodeFournisseur,
                    RAISONSOCIALE: d.RaisonSociale,
                    FORMEJURIDIQUE: d.FormeJuridique,
                    CODEPAYS: d.CodePays,
                    NUMCONTRIBUABLE: d.NumContribuable,
                    CONTACT: d.Contact,
                    STATUTSCREENING: d.StatutScreening,
                    ESTCLIENT: d.EstClient,
                    CODECLIENTREF: d.CodeClientRef,
                    ESTACTIF: d.EstActif,
                    // Libellés pour les SearInputG (lib_ + Name)
                    lib_CODEPAYS: d.LIBELL || "",
                    lib_CODECLIENTREF: d.NomClientRef || "",
                    lib_FORMEJURIDIQUE: d.LibelleFormeJuridique || ""
                });

                setModife(false);
                setAnnule(false);
                setConsulte(true);
            } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "info" });
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.error(err);
            SweetAlert.fire("Erreur", "Impossible de joindre le serveur", "error");
        });
    }

    // --- PHASE 3 : CRÉATION ---
    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setAnnule(false);
        setEtatG(true); 
        setFormactve(false); 
        setSbmit('add');
    }

    // --- PHASE 2 : MODIFICATION ---
    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setEtatG(true); 
        setFormactve(false);
        setSbmit('modif');
    }

    // --- RÉINITIALISATION ---
    function HandleAnnul() {
        setEtatG(false);
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
    }

    // --- PHASE 4 : ENGAGEMENT (SAVE/UPDATE) ---
    const onFinish = (values: any) => {
        const isAdd = sbmit === "add";
        const url = isAdd ? Data.ApiUrl.CreateFournisseur : Data.ApiUrl.UpdateFournisseur;

        // Préparation du payload conforme au DTO C# (PascalCase)
        const estClient = values.ESTCLIENT || false;
        const payload = {
            CodeFournisseur: values.CODEFOURNISSEUR,
            RaisonSociale: values.RAISONSOCIALE,
            FormeJuridique: values.FORMEJURIDIQUE || null,
            Pays: values.CODEPAYS,
            NumContribuable: values.NUMCONTRIBUABLE || null,
            Contact: values.CONTACT || "",
            StatutScreening: values.STATUTSCREENING || "EN_ATTENTE",
            EstClient: estClient,
            CodeClientRef: estClient ? (values.CODECLIENTREF || null) : null,
            EstActif: values.ESTACTIF || false
        };

        SweetAlert.fire({
            title: isAdd ? "Enregistrement" : "Modification",
            text: `Voulez-vous valider la fiche du fournisseur : ${values.RAISONSOCIALE} ?`,
            showCancelButton: true,
            confirmButtonColor: "#116599",
            cancelButtonColor: "darkred",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            icon: 'question'
        }).then((res) => {
            if (res.isConfirmed) {
                setLoading(true);
                let encryptedData = Crypter.encrypt(JSON.stringify(payload));
                
                const config = {
                    method: isAdd ? 'post' : 'put',
                    url: url,
                    data: encryptedData,
                    headers: { 'Authorization': authHeader(), 'Content-Type': 'application/json' }
                };

                axios(config).then((response) => {
                    setLoading(false);
                    const resJson = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (resJson.StatutCode === 200) {
                        SweetAlert.fire("Succès", resJson.Message, "success");
                        HandleAnnul();
                    } else {
                        SweetAlert.fire({ title: resJson.Message, text: resJson.Result, icon: "warning" });
                    }
                }).catch((err) => {
                    setLoading(false);
                    console.error(err);
                    SweetAlert.fire("Erreur", "Le serveur a refusé la transaction (Vérifiez la BD)", "error");
                });
            }
        });
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span><TeamOutlined /> Identification Fournisseur</span>,
            children: <Tab1 
                EtatG={EtatG}
                form={form} 
                disabledForm={FormAct}
                sbmit={sbmit}
            />
        }
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> 
                <b> RÉFÉRENTIEL DES FOURNISSEURS </b> 
            </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form 
                    form={form} 
                    onFinish={onFinish} 
                    onFinishFailed={(error) => console.log("Validation échouée :", error)}
                    preserve
                    labelAlign="left"
                >
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' disabled={Consultactv} onClick={HandleConsult} block>Consulter</Button>
                                <Button size='large' disabled={Ajoutactv} onClick={HandleAjout} block>Ajouter</Button>
                                <Button size='large' disabled={Modifactv} onClick={HandleModif} block>Modifier</Button>
                                <Button size='large' disabled={Enrege} htmlType="submit" block>Enregistrer</Button>
                                <Button size='large' disabled={Annulactv} onClick={HandleAnnul} block>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default FournisseurPage;